<div class="fw-assign-container d-flex flex-column">
  <span class="fw-assign-text">Select a Field worker to assign</span>

  <div class="d-flex flex-column">
    <span class="fw-text">Field worker</span>
    <!-- <form (ngSubmit)="assignToFW()">

    </form> -->
    <mat-form-field class="select-mat-form-field mt-2">
      <mat-select
        placeholder="(Select/search)"
        (selectionChange)="onChange($event)"
      >
        <mat-option
          *ngFor="let item of fwNames"
          [value]="item.value"
          >{{ item.label }}</mat-option
        >
      </mat-select>
  </mat-form-field>

    <!-- <select
      class="form-select mt-1"
      aria-label="Default select"
      (change)="onChange($event)"
    >
      <option selected>(Select/search)</option>
      @for (item of fwNames; track item) {
      <option [value]="item.value">{{ item.label }}</option>
      }
    </select> -->

    <button
      class="dp-primary-btn fw-assign-btn fw-assign-gap" (click)="assignToFW()"
    >
      Assign
    </button>
    <span
      class="cancel-text text-center fw-assign-gap"
      (click)="closeFWDialog()"
      mat-dialog-close
      >No, cancel</span
    >
  </div>
</div>
